import type { OpenShiftListItem } from "../../Shift/Open/types";
import { useFortuneCookieInjector } from "./ShiftInjectors/useFortuneCookieInjector";
import { useInAppAdInjector } from "./ShiftInjectors/useInAppAdInjector";

// Injected content, ads, banners, tutorial links, orchestration hooks, etc.
export function useShiftListInjector(shifts: OpenShiftListItem[]): OpenShiftListItem[] {
  let injectedShifts = useInAppAdInjector(shifts);
  const fortuneCookieInjectedShifts = useFortuneCookieInjector(injectedShifts);

  // The injector handles feature flag check internally
  injectedShifts = fortuneCookieInjectedShifts;

  return injectedShifts;
}
